import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface settingsType { isRunForProcess: boolean, isWorkflowRun: boolean, theme: 'light' | 'dark', showContactUS: boolean };
interface settingsTypeOpt { isRunForProcess?: boolean, isWorkflowRun?: boolean, theme?: 'light' | 'dark', showContactUS?: boolean  };

const initialState: { data: settingsType } = { 
   data: { 
      isRunForProcess: false, 
      isWorkflowRun: false, 
      theme: 'dark',
      showContactUS: false
   }};

export const settingsSlice = createSlice({
   name: 'settings',
   initialState,
   reducers: {
      reduxUpdateSettings: (state, action: PayloadAction<settingsTypeOpt>) => {
         state.data = { ...state.data, ...action.payload };
      },
   }
});

export const { reduxUpdateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;